import { create } from "zustand";

interface OrderStore {
  order: any;
  route: any;
  setOrder: (order: any) => void;
  setRoute: (route: any) => void;
}

export const useOrderStore = create<OrderStore>((set) => ({
  order: null,
  setOrder: (order: any) => set(() => ({ order })),
  route: null,
  setRoute: (route: any) => set(() => ({ route })),
}));
